// @TODO: <HEALTH2019>
(function () {
    App.directive('healthFormComplaint', healthFormComplaintDirective);
    healthFormComplaintDirective.$inject = ['Config'];

    function healthFormComplaintDirective(Config) {
        return {
            restrict: 'E',
            scope: {
                onFormSubmit: "&",
                busy: '<'
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/health-form-complaint.html',
            controller: HealthFormComplaintController,
            controllerAs: '$ctrl',
            bindToController: true
        }
    }

    HealthFormComplaintController.$inject = ['popUpService'];

    function HealthFormComplaintController(popUpService) {
        var self = this;
        self.model = {
            type: 'COMPLAINT',
            complaint: '',
            agreements: {
                terms: false
            }
        };
        self.formComplaint = null;

        self.formSubmitted = function (form) {
            if (!self.model.agreements.agreementsFirst
                || !self.model.agreements.agreementsSecond
                || !self.model.agreements.agreementsThird
                || !self.model.agreements.agreementsFourth) {
                popUpService.showPopUp({
                    head: 'Wystąpił błąd',
                    content: 'Aby wysłać formularz należy zaznaczyć wszystkie wymagane zgody'
                });
                return;
            }
            if (form.$invalid) {
                popUpService.showPopUp({
                    head: 'Wystąpił błąd',
                    content: 'Aby wysłać formularz należy wypełnić prawidłowo wszystkie pola'
                });
                return;
            }
            self.onFormSubmit && self.onFormSubmit({$event: self.model});
        }
    }
})();
// @TODO: </HEALTH2019>
